import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";
import ScheduleModel from '../../../models/ScheduleModel';

export default async function getSchedules(
  eventId = '',
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/schedule/getSchedules?eventId=${eventId}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = {
      data: [],
      count: _ret.data.data.length,
    };
    for (let i = 0; i < _ret.data.data.length; i++) {
      const _item = _ret.data.data[i];
      _return.data.push(ScheduleModel({
        id: _item.id,
        eventId: _item.eventId,
        title: _item.title,
        description: _item.description,
        startDate: _item.startDate,
        startTime: _item.startTime,
        endTime: _item.endTime,
        restrictedToAssociates: _item.restrictedToAssociates,
      }));
    }
    return _return;
  } catch (error) {
    console.log('Error getSchedules', error);
    throw error;
  }
}
